import { InsurancePlanType } from './InsurancePlan'
import { ViewNavigationConfiguration, DefaultViewType } from './ViewNavigation'

export const enum DeployedEnv {
  UNKNOWN = 'unknown',
  LOCAL = 'local',
  DEV = 'dev',
  TEST = 'test',
  STAGE = 'stage',
  PROD = 'prod',
}

export type CommerceEnv = 'dev' | 'int' | 'uat' | 'prod'

export type EnvHostInfo = {
  commerceEnv: CommerceEnv
  [brand: string]: string
}

export type EnvApiKeyInfo = {
  commerceEnv: CommerceEnv
  keys: {
    [brand: string]: Record<string, string>
  }
}

type RxHelpGuideOptions = {
  hideGlasses?: boolean
  hideContacts?: boolean
  hideHowToRead?: boolean
  hidePhotos?: boolean

  glassesrx?: {
    enableWhatSection?: boolean
    enablePrismSection?: boolean
  }
}

type FeatureConfig_CAFlow = {
  viewNavigation?: ViewNavigationConfiguration
  clickableTooltip?: boolean
  rxhelpGuideOptions?: RxHelpGuideOptions
  disableValidateRxAnimation?: boolean
}

type FeatureConfig_VDFlow = {
  viewNavigation?: ViewNavigationConfiguration
  disableQuoteFreeShipping?: boolean
  disableStrictSSNValidation?: boolean
}

type FeatureConfig_USFlow = {
  disableEyemedPlusLogo?: boolean
  disableInsuranceToggleMessages?: boolean
  disableScheduleEyeExamLink?: boolean
  enableDistributeBenefits?: boolean
}

export type ContactUsOption = 'phone' | 'chat' | 'faq' | 'email'

export type FeatureConfig = {
  disableAuthTokenForGuest?: boolean
  disableInsurerConfigurationInitialFetch?: boolean
  validateInsurerEligibleProduct?: boolean
  contactUs?: ContactUsOption[]
  defaultView?: DefaultViewType
} & FeatureConfig_CAFlow &
  FeatureConfig_VDFlow &
  FeatureConfig_USFlow

export type HostInfo = {
  apiHost: EnvHostInfo
  apiKey: EnvApiKeyInfo
  feature?: FeatureConfig
  env: DeployedEnv
}
